// extracted by mini-css-extract-plugin
module.exports = {"module_content":"module_content--WsAeI","module_title":"module_title--BK37P","title":"title--elcdy"};